import { css } from 'emotion';

export const main = css`
  display: flex;
  flex-direction: column;
  flex: 4;
  position: relative;
`;

export const mainBlock = css`
  background-color: #fff;
`;

export const sideView = isOpen => css`
  font-family: ProximaNova;
  flex-direction: column;
  flex: 1;
  background-color: #232f42;
  position: fixed;
  left: ${isOpen ? '0px' : '-320px'};
  width: 320px;
  top: 0px;
  bottom: 0px;
  display: flex;
  will-change: left, margin;
  transition: left 0.4s ease, margin 0.4s ease;
  z-index: 21;
`;

export const courseText = css`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  margin-bottom: 0px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media all and (max-width: 767px) {
    width: 253px;
  }
`;

export const backContainer = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;

  @media all and (max-width: 767px) {
    display: none;
  }
`;

export const backButton = css`
  font-size: 14px !important;
  letter-spacing: -0.1px !important;

  svg {
    margin-right: 6px;
    height: 10px;
    width: 5px;
  }
`;

export const teachButton = css`
  svg {
    margin-right: 6px;
    height: 14px;
    width: 14px;
  }
`;

export const courseName = theme => css`
  color: ${theme.color.grey3};
  white-space: normal;
  font-size: 20px;
`;

export const progressBarFill = percent => css`
  border-radius: 7px;
  height: 6px;
  background-color: #4a90e2;
  position: relative;
  width: 100%;
  right: ${100 - percent}%;
`;

export const mobileTeachBtn = css`
  position: absolute;
  right: -27px;
  bottom: -2px;
`;
